import React from 'react';
import Link from 'next/link';
import Image from 'next/image';

const steps = [
    {
        title: 'Poišči točko',
        description: (
            <>
                S pomočjo KZV iskalnika{' '}
                <Link className="underline" href="/ideje/nagradni-izbor">
                    poišči izletno točko
                </Link>
                , ki sodeluje v natečaju.
            </>
        ),
        number: '1.'
    },
    {
        title: 'Naloži fotografije',
        description: (
            <>
                Na točko naloži svoje fotografije. Če še nimaš KZV računa, si ga{' '}
                <Link className="underline" href={'/prijava'}>
                    hitro in preprosto ustvari
                </Link>
                .
            </>
        ),
        number: '2.'
    },
    {
        title: 'Fotografije poglej na svojem profilu',
        description: (
            <>
                Svoje naložene fotografije si lahko pogledaš na svojem{' '}
                <Link className="underline" href="/profil">
                    profilu
                </Link>
                . <br />
                <strong>Ne pozabi</strong> - več kot jih dodaš, več možnosti za nagrado imaš.
            </>
        ),
        number: '3.'
    },
    {
        title: 'Zaključek: 1. Avgust',
        description: (
            <>
                KZV bo izmed vseh naloženih fotografij 1. 8. izbral 40 finalistov, ki se bodo uvrstili v drugi krog,
                prav tako pa bo izžrebal 15 prejemnikov KZV majic.
            </>
        ),
        number: '4.'
    },
    {
        title: 'Finalno glasovanje',
        description: (
            <>
                Glasovanje za zmagovalno fotografijo bo potekalo med 1. in 7. avgustom na portalu KZV in na družbenih
                omrežjih. Avtor z največ glasovi bo prejel glavno nagrado fotoaparat Nikon Z 30.
            </>
        ),
        number: '5.'
    }
];

const ParticipationStep = ({ step }) => {
    return (
        <div className={'flex relative max-w-[320px] pl-6 items-center z-10'}>
            <div className="text-brand text-opacity-20 absolute -left-3 -top-4 text-8xl font-bold font-serif">
                {step.number}
            </div>
            <div className="relative z-10 pt-1">
                <h4 className="font-serif font-bold tracking-wide mb-1 leading-tight">{step.title}</h4>
                <p className={'text-lg leading-tight'}>{step.description}</p>
            </div>
        </div>
    );
};

const ArrowDown = () => {
    return (
        <div className="pl-12">
            <svg width="24" height="66" viewBox="0 0 24 66" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M13.5 2.10156C13.5 1.27314 12.8284 0.601563 12 0.601562C11.1716 0.601562 10.5 1.27314 10.5 2.10156L13.5 2.10156ZM10.9393 64.6622C11.5251 65.248 12.4749 65.248 13.0607 64.6622L22.6066 55.1163C23.1924 54.5305 23.1924 53.5807 22.6066 52.995C22.0208 52.4092 21.0711 52.4092 20.4853 52.995L12 61.4802L3.51472 52.995C2.92893 52.4092 1.97918 52.4092 1.3934 52.995C0.807609 53.5807 0.807609 54.5305 1.3934 55.1163L10.9393 64.6622ZM10.5 2.10156L10.5 63.6016L13.5 63.6016L13.5 2.10156L10.5 2.10156Z"
                    fill="#FBA919"
                    fillOpacity={0.2}
                />
            </svg>
        </div>
    );
};
const HowToParticipate = () => {
    return (
        <div className={'max-w-4xl mx-auto'}>
            <div className="flex flex-col lg:flex-row gap-4 md:gap-12 items-center">
                <ParticipationStep step={steps[0]} />
                <Image src="/images/foto-izbor/iskalnik@2x.png" alt={'Foto search'} width={829} height={382} />
            </div>
            <div className="-mt-8 hidden lg:block">
                <ArrowDown />
            </div>
            <div className="flex flex-col lg:flex-row mt-6 gap-4 md:gap-12 items-center">
                <div className={'space-y-8 flex-shrink-0'}>
                    <ParticipationStep step={steps[1]} />
                    <ParticipationStep step={steps[2]} />
                </div>

                <Image src="/images/foto-izbor/upload@2x.png" alt={'Foto upload'} width={829} height={520} />
            </div>
            <div className="mt-6 hidden lg:block">
                <ArrowDown />
            </div>
            <div className="flex flex-col lg:flex-row mt-6 md:-mt-6 gap-4 md:gap-12 items-center">
                <div className={'space-y-8 flex-shrink-0'}>
                    <ParticipationStep step={steps[3]} />
                    <ParticipationStep step={steps[4]} />
                </div>

                <Image
                    src="/images/foto-izbor/landing-nagrade-mobile@2x.png"
                    alt={'Nagrade'}
                    width={750}
                    height={1003}
                    className={'lg:max-w-sm mx-auto'}
                />
            </div>
        </div>
    );
};

export default HowToParticipate;
